import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommitmentsGridPart } from '../../../../../ui/widget/shared-grids/commitments-grid/commitments-grid.part';
import { AdmissionsAreaService } from '../../../../admissions/admissions-area.service';
import { AdmissionsCommitmentsService } from '../../admissions-commitments.service';


@Component({
	selector: 'admissions-commitments-view-part',
	standalone: true,
	imports: [CommitmentsGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './commitments-view.part.html',
})
export class AdmissionsCommitmentsViewPart {

	private readonly areaService = inject(AdmissionsAreaService);
	public readonly pageService = inject(AdmissionsCommitmentsService);

	public commitments = computed(() => {
		const data = this.areaService.admissionsData();
		return data?.commitments ?? [];
	});

}